import { render, staticRenderFns } from "./BookRideOptionsV2.vue?vue&type=template&id=00f54a2f&scoped=true&"
import script from "./BookRideOptionsV2.vue?vue&type=script&lang=js&"
export * from "./BookRideOptionsV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f54a2f",
  null
  
)

export default component.exports